export const RESULTS_PER_PAGE = 100;



// WEBPACK FOOTER //
// ./src/util/constants.js